/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';

/**
 * A command used to delete all examples from an AsyncAPI message.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllMessageExamplesCommand_Aai20 extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldExamples : Array<any>;

    public constructor(operationNode? : any) {
        if(((operationNode != null && operationNode instanceof <any>AaiOperation) || operationNode === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            (() => {
                this._parentPath = Library.createNodePath(operationNode);
            })();
        } else if(operationNode === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllMessageExamplesCommand_Aai20] Executing.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        this._oldExamples = operation.message.examples;
        operation.message.examples = null;
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllMessageExamplesCommand_Aai20] Reverting.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        if(this._oldExamples == null || this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        operation.message.examples = this._oldExamples;
    }
}
DeleteAllMessageExamplesCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllMessageExamplesCommand_Aai20";
DeleteAllMessageExamplesCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




